export async function slotShowUseCase(id, slotRepository) {
    const result = await slotRepository.show(id);

    const entity = new slotRepository.model(result);
        
    if (!entity.isValid()) {
        throw new Error("Estación inválido");
    }

    return entity;
}